<template>
  <div class="flex-x-center flex-between ant-popover-inner-content_">
    <div class="actionTitle">
      {{ title }}
    </div>
    <div class="flex-x-center" @click.stop>
      <div
        v-if="!notAdd"
        class="pointer"
        @click="emit('categoty', 'add')"
        style="margin-right: 10px;"
      >
        <PlusOutlined></PlusOutlined>
      </div>
      <a-popover placement="bottom">
        <template #content>
          <div>
            <div @click="emit('categoty', 'update')" class="pointer action">
              <PlusOutlined></PlusOutlined>
              编辑
            </div>
            <!-- <div @click="emit('categoty', 'del')" class="pointer action">
              <PlusOutlined></PlusOutlined>
              删除
            </div> -->
          </div>
        </template>
        <div class="pointer" style="margin-right: 10px;">
          <EllipsisOutlined></EllipsisOutlined>
        </div>
      </a-popover>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { PlusOutlined, EllipsisOutlined } from '@ant-design/icons-vue'

defineProps({
  title: {
    type: String,
    default: ''
  },
  notAdd: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['categoty'])
</script>

<style lang="scss">
.pointer {
  cursor: pointer;
  user-select: none;
}
.flex-x-center {
  display: flex;
  align-items: center;
}
.flex-between {
  justify-content: space-between;
}

.actionTitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action {
  width: 80px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  &:hover {
    background-color: rgba($color: #000000, $alpha: 0.2);
  }
}

.ant-popover-inner-content_ .ant-popover-inner-content {
  padding: 0;
}
</style>
